<template>

  <v-container fluid>

    <!-- 갤러리 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog1" @keydown.esc="dialog1 = false" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ this.editedIndex == -1 ? $t('common_title_insert') : $t('common_title_edit') }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog1 = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row>
                  <v-text-field v-model="editedItem.NAME" :label="$t('gallerylist_col1')"></v-text-field>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" large rounded @click="dialog1 = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" large rounded @click="save_gal">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 이미지 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog2" @keydown.esc="dialog2 = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ this.editedIndex2 == -1 ? $t('common_title_insert') : $t('common_title_edit') }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog2 = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row>
                  <v-img
                    :src="editedItem2.IMAGE"
                    height="100" contain aspect-ratio="1"
                    >
                  </v-img>
                </v-row>
                <v-row>
                  <v-col v-if="editedIndex2 == -1" md="12" sm="12" xs="12">
                    <v-file-input accept="image/*" :label="$t('gallerylist_label1')" v-model="uploadFile" @change="changefile" multiple></v-file-input>
                  </v-col>
                  <v-col v-if="editedIndex2 > -1" md="12" sm="12" xs="12">
                    <v-file-input accept="image/*" :label="$t('gallerylist_label1')" v-model="uploadFile" @change="changefile"></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-text-field v-model="editedItem2.DESC" :label="$t('gallerylist_col4')"></v-text-field>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" large rounded @click="dialog2 = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" large rounded @click="save_img">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" dense no-gutters>
      <v-col cols="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
    </v-row>

    <v-row align="start" dense>

      <!-- 정렬조건 -->
      <v-col cols="12" md="6" sm="12" xs="12">
        <v-row dense no-gutters justify="center" align="center">

          <template v-if="grade >= 50">
            <v-col cols="12" md="4" sm="12" xs="12">
              <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
            </v-col>
          </template>
          <template v-else>
            <v-spacer/>            
          </template>          
          
          <v-col cols="12" md="4" sm="12" xs="12" class="pa-0">
            <v-text-field 
              dense single-line clearable
              @keyup.enter="search_run" 
              v-model="search_keyword" 
              :placeholder="$t('common_search_holder')"
              outlined height="43"
              color="#808080"
              hide-details
              />
          </v-col>

          <v-col cols="6" md="2" sm="6" xs="6" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
          </v-col>
          <v-col cols="6" md="2" sm="6" xs="6" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="insertnewgal">{{$t("common_insert")}}</v-btn>
          </v-col>

        </v-row>

      </v-col>

      <v-col cols="6" md="6" sm="12" xs="12">
        <v-row>
          <v-spacer/>
          <v-col>
            <label style="font-size:25px">{{ PARENT_ITEM != null ? PARENT_ITEM.NAME : "" }}</label>
          </v-col>
          <v-col>
            <v-btn v-if="PARENT_ITEM != null" style="width:94%" class="search_btn_freesize" outlined large @click="insert_img">{{$t('gallerylist_label2')}}</v-btn>
          </v-col>
        </v-row>
      </v-col>

  </v-row>
    
  <v-row align="start">
    
    <v-col cols="12" md="6" sm="12" xs="12">
      
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        item-key="IDX"
        :loading="loading"
        >

        <template v-slot:header.NAME>
          <label class="cheader_normal" >{{$t("gallerylist_col1")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("gallerylist_col2")}}</label>
        </template>
                
        <template v-slot:item.NAME="{ item }">
            <a  @click="edit_item(item)">{{item.NAME}}</a>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_gal(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_gal(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
      <v-row>
        <v-col class="d-flex justify-center">
        <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
        <span v-for="n in subpage" :key="n.id">
            <span v-if="page == bottompage-1+n">
                <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
            </span>
            <span v-else>
                <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
            </span>
        </span>
        <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-col>
    
    <v-col v-if="PARENT_ITEM != null" cols="12" md="6" sm="12" xs="12">
      <!-- 테이블 -->
      <v-data-table
        :headers="headers2"
        :items="itemList2"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        item-key="IDX"
        :loading="loading2"
        >
        <template v-slot:header.IMAGE>
          <label class="cheader_normal" >{{$t("gallerylist_col3")}}</label>
        </template>
        <template v-slot:header.DESC>
          <label class="cheader_normal" >{{$t("gallerylist_col4")}}</label>
        </template>
        <template v-slot:header.REG_DATE>
          <label class="cheader_normal" >{{$t("gallerylist_col5")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("gallerylist_col2")}}</label>
        </template>

        <!-- 특정 컬럼 커스텀 처리 -->
        <template v-slot:item.IMAGE="{ item }">
          <v-img :src="item.IMAGE" height="80" width="200" contain/>
        </template>
        <!-- 액션처리 - 아이템 슬롯을 재정의 할 수 있지만 기본값이 반응형에 더 최적화 되어있다. -->
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_img(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_img(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>

      <v-row>
      <v-col class="d-flex justify-center">
        <v-btn v-if="bottompage2 > 10" icon  small @click="prev2()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
        <span v-for="n in subpage2" :key="n.id">
            <span v-if="page2 == bottompage2-1+n">
                <v-btn color="red" icon small @click="loadpage2(bottompage2-1+n)">{{bottompage2-1+n}}</v-btn>
            </span>
            <span v-else>
                <v-btn icon small @click="loadpage2(bottompage2-1+n)">{{bottompage2-1+n}}</v-btn>
            </span>
        </span>
        <v-btn v-if="subpage2 == 10" icon small @click="next2()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
      </v-col>
      </v-row>

    </v-col>

  </v-row>
  

  </v-container>
</template>

<script>
export default {


    data: () => ({

      dialog1: false,
      dialog2: false,
      ucnt:0,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      defaultItem: {
          IDX:'',
          ADMIN_IDX:'',
          COMIDX:'',
          NAME:'',
      },
      editedItem: {
      },
      

      //테이블 정의
      headers: [
        {text: '폴더명', value: 'NAME', sortable: true, align:'center'},
        {text: '수정/삭제',   value: 'actions', sortable: false, align:'center' },
      ],
      itemList: [],

      //검색 파라메터
      search_type : 'NAME',   
      search_keyword : '',

      //정렬 파라메터
      sort_type : 'NAME ASC',   //이름

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      
      //갤러리 사진들
      totalcnt2 : 0,      //전체 아이템 개수
      page2 : 0,
      maxpage2 : 0,       //전체 페이지 개수
      startpage2 : 1,     //시작 인덱스
      bottompage2 : 1,    //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage2 : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading2 : false,   //로딩 표시

      //파일 업로드
      uploadFile : null,

      //CRUD 관련
      dialogTitle2: '추가하기',   //다이얼로그 제목
      editedIndex2: -1,          //-1이면 신규, -1보다 크면 업데이트
      defaultItem2: {
          IDX:'',
          ADMIN_IDX:'',
          GALLERY_IDX:'',
          DESC:'',
          IMAGE:'',
          REG_DATE:'',
      },
      editedItem2: {
      },
      

      //테이블 정의
      headers2: [
        {text: '이미지',  value: 'IMAGE', sortable: false, align:'center' },
        {text: '설명',    value: 'DESC', sortable: true, align:'center'},
        {text: '등록일시',    value: 'REG_DATE', sortable: true, align:'center' },
        {text: '수정/삭제',    value: 'actions', sortable: false, align:'center' },
      ],
      itemList2: [],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',

      grade : 0,

      PARENT_ITEM:null,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t('common_nograde')).then(()=>{
          this.$router.push("Login");
        });
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      edit_gal(item){
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.editedIndex = this.itemList.indexOf(item)
        this.dialog1 = true;
      },
      
      delete_gal(item){

        this.$confirm(this.$t('gallerylist_msg1'))
        .then(() => {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/GalleryDelete',{
                IDX:item.IDX
              , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      edit_img(item){
        this.editedItem2 = item;
        this.editedIndex2 = this.itemList2.indexOf(item)
        this.dialog2 = true;
      },
      
      delete_img(item){

        this.$confirm(this.$t('gallerylist_msg2'))
        .then(() => {
          
          this.loading2 = true;
          this.$http.post(this.$host+'/api/GalleryImageDelete',{
                IDX:item.IDX
              , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading2 = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page2;
                this.page2 = 0;
                this.loadpage2(p);
              }); 
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
              this.$alert(this.$t("common_delete_error"));
          });      
          
        });

      },



      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }

          this.PARENT_ITEM = null
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/GallList',{
                search_type:this.search_type
              , search_keyword: this.search_keyword == null || this.search_keyword == undefined ? '' : escape(this.search_keyword)
              , sort_type:this.sort_type  
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },

      prev2(){
          this.bottompage2 = this.bottompage2 - 10 >= 1 ? this.bottompage2 - 10 : 1;
          this.subpage2 = this.maxpage2 - this.bottompage2 >= 10 ? 10 : this.maxpage2 - this.bottompage2+1;
          var temp_page2 = this.bottompage2 + this.subpage2 - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage2(temp_page2);
      },
      next2(){
          this.bottompage2 = this.bottompage2 + 10 <= this.maxpage2 ? this.bottompage2 + 10 : this.maxpage2;
          this.subpage2 = this.maxpage2 - this.bottompage2 >= 10 ? 10 : this.maxpage2 - this.bottompage2+1;
          var temp_page2 = this.bottompage2;
          this.loadpage2(temp_page2);
      },

      makepaging2(){
        var div1 = this.totalcnt2 / this.pagerow; 
        var div2 = this.totalcnt2 % this.pagerow;
        if(div2 == 0){  
            this.maxpage2 = parseInt(div1);    
        }else{
            this.maxpage2 = parseInt(div1+1);
        }
        if(this.bottompage2 == 1){
          this.subpage2 = this.maxpage2 - this.bottompage2 >= 10 ? 10 : this.maxpage2 - this.bottompage2+1;
        }
      },


      //아이템 수정
      edit_item(item){
        
        this.PARENT_ITEM = item;
        this.page2 = 1;
        
        this.$http.post(this.$host+'/api/GallImgList',{
                page: this.page2
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , GALLERY_IDX: this.PARENT_ITEM.IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt2 = result.data.totalcnt;
                this.makepaging2();
                const list = result.data.resultData;

                this.itemList2.splice(0, this.itemList2.length);   //데이터 초기화
                list.forEach(element => {
                    this.itemList2.push(element); 
                });
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading2 = false;
        });

      },

      loadpage2(p){

          this.loading2 = true;
          this.page2 = p;

        this.$http.post(this.$host+'/api/GallImgList',{
                page: this.page2
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , GALLERY_IDX: this.PARENT_ITEM.IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
            

            this.loading2 = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt2 = result.data.totalcnt;
                this.makepaging2();
                const list = result.data.resultData;
                this.itemList2.splice(0, this.itemList2.length);   //데이터 초기화
                list.forEach(element => {
                    this.itemList2.push(element); 
                });
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading2 = false;
        });

      },

      save_gal(){

        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('gallerylist_msg3'));
          return;
        } 

        if(this.editedIndex > -1){

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/GalleryUpdate',{
                NAME: escape(this.editedItem.NAME)
              , IDX: this.editedItem.IDX
              , COM_IDX: this.editedItem.COM_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });
      
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });

        }else{

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/GalleryInsert',{
                NAME: escape(this.editedItem.NAME)
              , COM_IDX: this.SEARCH_COM_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });
      
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });

        }

        this.dialog1 = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)

      },
      
      insert_img(){
        
        if(this.itemList2.length > 50){
          this.$alert(this.$t('gallerylist_msg4'));
          return;
        }

        this.editedItem2 = {};
        this.editedIndex2 = -1;
        this.dialog2 = true;

      },

      save_img(){

        if(this.editedItem2.IMAGE == undefined || this.editedItem2.IMAGE.length < 1){
          if(this.uploadFile == undefined || this.uploadFile.length < 1){
            this.$alert(this.$t('gallerylist_msg5'));
            return;
          } 
        }

        if(this.editedIndex2 > -1){
          
          //수정
          this.loading2 = true;

          const formData = new FormData();
          formData.append("FOLDER", this.SEARCH_COM_IDX+"/gallery");
          formData.append("DESC", this.editedItem2.DESC);
          formData.append("ADMIN_IDX", this.editedItem2.ADMIN_IDX);
          formData.append("GALLERY_IDX", this.editedItem2.GALLERY_IDX);
          formData.append("IDX", this.editedItem2.IDX);
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/GalleryImageUpdate', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page2;
                  this.page2 = 0;
                  this.loadpage2(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_process_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading2 = false;
            this.$alert(this.$t('common_process_fail'));
          });          


        }else{

          if(this.itemList2.length + this.uploadFile.length > 50){
            this.$alert(this.$t('gallerylist_msg4'));
            return;
          }

          //추가
          this.loading2 = true;
          this.ucnt = 0;

          const tempFile = this.uploadFile;
          for(const img of this.uploadFile){

            if(img.size/1024/1024 > 5){
              this.ucnt++;
              this.$alert(img.name + this.$t('gallerylist_msg6'));
              if(this.ucnt == this.uploadFile.length){
                const p = this.page2;
                this.page2 = 0;
                this.loadpage2(p);
              }
              continue;
            }

            if(!img.type.match(/^image\/(png|jpeg)$/)) {
              this.ucnt++;
              this.$alert(img.name + this.$t('gallerylist_msg7'));
              if(this.ucnt == this.uploadFile.length){
                const p = this.page2;
                this.page2 = 0;
                this.loadpage2(p);
              }
              continue;
            }

            const formData = new FormData();
            formData.append("FOLDER", this.SEARCH_COM_IDX+"/gallery");
            formData.append("DESC", this.editedItem2.DESC);
            formData.append("ADMIN_IDX", this.$session.get("ADMIN_IDX"));
            formData.append("GALLERY_IDX", this.PARENT_ITEM.IDX);
            formData.append("COM_IDX", this.SEARCH_COM_IDX);
            formData.append("customfile", img);
            this.$http.post(this.$host+'/api/GalleryImageInsert', formData, {
              headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
            })
            .then((result)=>{
              this.ucnt++;
              
              

              this.loading = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(this.ucnt == tempFile.length){
                  this.$alert(this.$t('common_insert_msg')).then(()=>{
                    const p = this.page2;
                    this.page2 = 0;
                    this.loadpage2(p);
                  });
                }

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t('common_process_fail'));
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.loading2 = false;
            });          

          }

        }

        this.dialog2 = false
        setTimeout(() => {
          this.editedItem2 = Object.assign({}, this.defaultItem2)
          this.editedIndex2 = -1
          this.uploadFile = null;
        }, 300)


      },



      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;        
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_COM_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },

      insertnewgal(){

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          this.dialog1 = true;

      },

      changefile(){

        if(this.editedIndex > -1 && this.uploadFile.length == 1){

          /*
          if(this.uploadFile.size/1024/1024 > 5){
            this.$alert("파일이 5MB를 초과하여 업로드할 수 없습니다.");
            return;
          }
          */

          var file = this.uploadFile;
          if (file && file.type.match(/^image\/(png|jpeg)$/)) {
            var temp = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
            this.editedItem2.IMAGE = temp;
          }

        }

      },


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>